'use client';
import Script from 'next/script';

import { BlockHeader, BlockHeaderContent } from '@/cms/BlockHeaderContentDC';
import { BlockWrapper } from '@/cms/BlockWrapperDC';
import { BlockComponentModel } from '@/cms/types';
import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';
import { useTrustpilotRef } from '@/integrations/trustpilot/utils';
import { defaultTheme } from '@/theme/themeProviderUtils';

type TrustpilotCarouselProps = {
  header: BlockHeader;
};

export type TrustpilotCarouselStrapiProps =
  BlockComponentModel<TrustpilotCarouselProps>;

const TrustpilotCarouselStrapi = (props: TrustpilotCarouselStrapiProps) => {
  const { header } = props.block;
  const theme = props.pageData?.theme || defaultTheme;
  const widgetRef = useTrustpilotRef();

  return (
    <BlockWrapper
      data-tracker-section={SECTION_NAMES.TEXT_IMAGE}
      contentFit='contained'
    >
      <BlockHeaderContent
        {...header}
        layoutOptions={{ constrainWidthWithPadding: true }}
      >
        <div className='h-60 w-full'>
          <Script
            type='text/javascript'
            src='//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
            async
          />
          <div
            ref={widgetRef}
            data-theme={theme}
            className='trustpilot-widget'
            data-locale='en-US'
            data-template-id='54ad5defc6454f065c28af8b'
            data-businessunit-id='67f91a41d68b154e79a253a4'
            data-style-height='240px'
            data-style-width='100%'
            data-token='74ba6778-1650-4fe8-b6d4-e9eccd553a23'
            data-stars='4,5'
            data-review-languages='en'
          />
        </div>
      </BlockHeaderContent>
    </BlockWrapper>
  );
};

export default TrustpilotCarouselStrapi;
